'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _ControlInput = require('@/components/ControlInput.vue');

var _ControlInput2 = _interopRequireDefault(_ControlInput);

var _TextStyle = require('@/customized-core/inputtools/TextStyle');

var _TextStyle2 = _interopRequireDefault(_TextStyle);

var _Emoji = require('@/customized-core/inputtools/Emoji');

var _Emoji2 = _interopRequireDefault(_Emoji);

var _AutoComplete = require('@/customized-core/AutoComplete.vue');

var _AutoComplete2 = _interopRequireDefault(_AutoComplete);

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	mixins: [_ControlInput2.default],
	methods: {
		closeTools: function closeTools() {
			if (this.active_tool) {
				this.closeInputTool();
			}
		},
		onToolClickTextStyle: function onToolClickTextStyle() {
			this.toggleInputTool(_TextStyle2.default);
		},
		onToolClickEmoji: function onToolClickEmoji() {
			this.toggleInputTool(_Emoji2.default);
		},
		inputKeyDown: function inputKeyDown(event) {
			var _this = this;

			var meta = false;

			if (navigator.appVersion.indexOf('Mac') !== -1) {
				meta = event.metaKey;
			} else {
				meta = event.ctrlKey;
			}

			if (this.autocomplete_open && this.$refs.autocomplete.handleOnKeyDown(event)) {
				return;
			}

			if (this.autocomplete_open && !this.autocomplete_filtering) {
				this.$refs.autocomplete.selectCurrentItem();
			}

			if (event.keyCode === 13) {
				event.preventDefault();
				this.submitForm();
			} else if (event.keyCode === 32) {
				if (_state2.default.setting('buffers.show_emoticons')) {
					var currentWord = this.$refs.input.getCurrentWord();
					var emojiList = _state2.default.setting('emojis');
					if (emojiList.hasOwnProperty(currentWord.word)) {
						var emoji = emojiList[currentWord.word];
						var url = _state2.default.setting('emojiLocation') + emoji + '.png';
						this.$refs.input.setCurrentWord('');
						this.$refs.input.addImg(currentWord.word + ' ', url);
					}
				}
			} else if (event.keyCode === 38) {
				event.preventDefault();
				this.historyBack();
				this.$nextTick(function () {
					_this.$refs.input.selectionToEnd();
				});
			} else if (event.keyCode === 40) {
				event.preventDefault();
				this.historyForward();
				this.$nextTick(function () {
					_this.$refs.input.selectionToEnd();
				});
			} else if (event.keyCode === 9 && !event.shiftKey && !event.altKey && !event.metaKey && !event.ctrlKey) {
				var _currentWord = this.$refs.input.getCurrentWord();
				var currentToken = _currentWord.word.substr(0, _currentWord.position);

				var items = this.buildAutoCompleteItems({
					users: true,
					buffers: true
				});
				this.openAutoComplete(items);
				this.autocomplete_filter = currentToken;

				this.autocomplete_filtering = false;
				event.preventDefault();
			} else if (meta && event.keyCode === 75) {
				this.toggleInputTool(_TextStyle2.default);
				event.preventDefault();
			} else if (meta && event.keyCode === 66) {
				this.toggleBold();
				event.preventDefault();
			} else if (meta && event.keyCode === 73) {
				this.toggleItalic();
				event.preventDefault();
			} else if (meta && event.keyCode === 85) {
				this.toggleUnderline();
				event.preventDefault();
			}
		}
	},
	components: {
		AutoComplete: _AutoComplete2.default
	}
};


//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/customized-core/ControlInput.vue
// module id = oGKR
// module chunks = 1